<template>
    <v-container class="margen">
        <v-row>
            <v-col cols="12" align="center" style="margin-top:3%;">
              <v-btn :to="$t('Alias.ProductosOficina')" text class="mx-3">{{ $t('Menu.ProductosOficina') }}</v-btn>
              <v-btn :to="$t('Alias.VentasOficina')" text class="mx-3">{{ $t('Menu.VentasOficina') }}</v-btn>
              <v-btn :to="$t('Alias.CapacitacionOficina')" text class="mx-3">{{ $t('Menu.CapacitacionOficina') }}</v-btn>
              <v-btn :to="$t('Alias.SoporteOficina')" text class="mx-3">{{ $t('Menu.SoporteOficina') }}</v-btn>
            </v-col>
            <v-col cols="12">
              <router-view />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Oficina'
}
</script>
